
import * as GFXEngine from './GFXEngine.js';
import * as init from './init.js';

var Engine = function () {

    // Instance stores a reference to the Singleton
    var _instance = void 0;

    function initialize(diwebsdk, configs, pathToWorker, ids, width, height, ratio) {

        var _width = void 0,
            _height = void 0,
            _ratio = void 0;

        function updateCanvasSize(width, height, ratio, video) {
            if (_width != width || _height != height || _ratio != ratio) {
                _width = width;
                _height = height;
                _ratio = ratio;
                return init.updateCanvasSize(width, height, ratio, video);
            }
            return Promise.resolve();
        }

        function setLook(lookObj, videoMode, detectFromCanvas, setBefore, updateImage) {
            init.setFutureImage(videoMode, detectFromCanvas, setBefore, updateImage);
            return init.setLook(videoMode ? lookObj.withSoftFocus : lookObj.look, videoMode, detectFromCanvas);
        }

        function setVideoMode(mode) {
            init.setVideoMode(mode);
        }

        function processFrames(bool) {
            init.processFrames(bool);
        }

        function snap(look, url) {
            return init.snap(look, url);
        }

        console.log('starting up makeup engine ...');
        window.GlamSTModule = GFXEngine.default;
        return init.start(diwebsdk, configs, pathToWorker, ids).then(function () {
            return updateCanvasSize(width, height, ratio);
        }).then(function () {
            // updateCanvasSize(width, height, ratio);
            return {
                updateCanvasSize: updateCanvasSize,
                setLook: setLook,
                setVideoMode: setVideoMode,
                processFrames: processFrames,
                snap: snap
            };
        });
    };

    return {

        // Get the Singleton instance if one exists
        // or create one if it doesn't
        instance: function instance(diwebsdk, configs, pathToWorker, ids, width, height, ratio) {

            if (!_instance) {
                return initialize(diwebsdk, configs, pathToWorker, ids, width, height, ratio).then(function (i) {
                    return _instance = i;
                });
            }

            return Promise.resolve(_instance);
        }

    };
}();

// const instance = new Engine();
// Object.freeze(instance);

export default Engine;